export enum SubscriptionStatus {
    Paid = "paid",
    Trial = "trial",
}
